export default function ({ id = '' }) {
    return {
        id,
        init() {
            const isAdded = this.isAddedToCompare();

            if (isAdded) {
                this.$el.classList.add('compare-icon--added-svg');
            }
        },
        isAddedToCompare() {
            const compare =
                this.$store.mageCacheStorage.data['compare-products'];

            if (this.id && compare) {
                return compare.items.some((item) => item.id === this.id);
            }
        }
    };
}
